if (!customElements.get('pdp-offers')) {
  class PdpOffers extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-offer-track]');
      this.cards = Array.from(this.querySelectorAll('[data-offer-card]'));
      this.dots = Array.from(this.querySelectorAll('[data-offer-dot]'));
      this.prevButton = this.querySelector('[data-offer-prev]');
      this.nextButton = this.querySelector('[data-offer-next]');
      this.detailsButton = this.querySelector('[data-offer-details]');
      this.copyButtons = Array.from(this.querySelectorAll('[data-offer-copy]'));
      this.priceEl = this.querySelector('[data-offer-price]');
      this.savingEl = this.querySelector('[data-offer-saving]');
      this.liveEl = this.querySelector('[data-offer-live]');
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      this.discountType = this.dataset.discountType || '';
      this.discountValue = Number(this.dataset.discountValue || 0);
      this.variantPrices = this.parsePrices(this.dataset.variantPrices);
      this.activeIndex = 0;
      this.pointerStartX = null;
      this.pointerStartY = null;
      this.scrollStart = 0;
      this.didDrag = false;
      this.dragLock = null;
      this.scrollFrame = 0;
      this.copyTimer = 0;

      this.onDetails = this.onDetails.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDot = this.onDot.bind(this);
      this.onCopy = this.onCopy.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onVariantClick = this.onVariantClick.bind(this);
      this.onVariantInput = this.onVariantInput.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      this.detailsButton?.addEventListener('click', this.onDetails);
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
      this.copyButtons.forEach((button) => button.addEventListener('click', this.onCopy));
      this.track?.addEventListener('scroll', this.onScroll, { passive: true });
      this.track?.addEventListener('pointerdown', this.onPointerDown);
      this.track?.addEventListener('pointermove', this.onPointerMove);
      this.track?.addEventListener('pointerup', this.onPointerUp);
      this.track?.addEventListener('pointercancel', this.onPointerUp);
      document.addEventListener('click', this.onVariantClick);
      document
        .querySelector('form[action="/cart/add"] input[name="id"]')
        ?.addEventListener('change', this.onVariantInput);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }

      this.updateChrome();
      this.updatePrice(this.dataset.variantId);
    }

    disconnectedCallback() {
      this.detailsButton?.removeEventListener('click', this.onDetails);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDot));
      this.copyButtons?.forEach((button) => button.removeEventListener('click', this.onCopy));
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('pointerup', this.onPointerUp);
      this.track?.removeEventListener('pointercancel', this.onPointerUp);
      document.removeEventListener('click', this.onVariantClick);
      document
        .querySelector('form[action="/cart/add"] input[name="id"]')
        ?.removeEventListener('change', this.onVariantInput);
      if (this.unsubscribeVariant) this.unsubscribeVariant();
      window.clearTimeout(this.copyTimer);
    }

    parsePrices(raw) {
      const map = {};
      String(raw || '')
        .split(',')
        .forEach((pair) => {
          const [id, price] = pair.split(':');
          if (id) map[id] = Number(price);
        });
      return map;
    }

    formatMoney(cents) {
      const value = Math.max(0, Number(cents) || 0) / 100;
      const withDecimals = value.toFixed(2);
      const noDecimals = String(Math.round(value));
      const withComma = withDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noTrailing = withComma.replace(/\.00$/, '');
      return this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, noTrailing)
        .replace(/Rs\.?\s*/gi, '₹');
    }

    discountCents(baseCents) {
      const type = String(this.discountType).toLowerCase();
      const amount = Number(this.discountValue) || 0;
      let discount = type.includes('percent')
        ? Math.round((baseCents * amount) / 100)
        : Math.round(amount * 100);
      if (discount < 0) discount = 0;
      if (discount > baseCents) discount = baseCents;
      return discount;
    }

    updatePrice(variantId) {
      const base = this.variantPrices[String(variantId)];
      if (base == null || !this.priceEl) return;
      const saving = this.discountCents(base);
      this.priceEl.textContent = this.formatMoney(base - saving);
      if (this.savingEl) this.savingEl.textContent = this.formatMoney(saving);
    }

    onVariantClick(event) {
      const card = event.target.closest('.custom-variant-card');
      if (!card?.dataset.variantId) return;
      this.updatePrice(card.dataset.variantId);
    }

    onVariantInput(event) {
      if (event.target?.value) this.updatePrice(event.target.value);
    }

    onVariantChange(event) {
      const variant = event?.data?.variant;
      if (variant?.id) this.updatePrice(variant.id);
    }

    onDetails() {
      const collapsed = this.classList.toggle('is-collapsed');
      this.detailsButton?.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }

    cardStep() {
      const card = this.cards[0];
      if (!card || !this.track) return 0;
      const row = this.querySelector('.pdp-offers__track') || this.track;
      const styles = window.getComputedStyle(row);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollToIndex(index) {
      if (!this.track) return;
      const max = this.cards.length - 1;
      const next = Math.min(max, Math.max(0, index));
      this.track.scrollTo({ left: next * this.cardStep(), behavior: 'smooth' });
    }

    onPrev() {
      this.scrollToIndex(this.activeIndex - 1);
    }

    onNext() {
      this.scrollToIndex(this.activeIndex + 1);
    }

    onDot(event) {
      const index = Number(event.currentTarget.dataset.index);
      if (Number.isNaN(index)) return;
      this.scrollToIndex(index);
    }

    onScroll() {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = 0;
        this.updateChrome();
      });
    }

    updateChrome() {
      if (!this.track || !this.cards.length) return;
      const step = this.cardStep();
      const index = step ? Math.round(this.track.scrollLeft / step) : 0;
      this.activeIndex = Math.min(this.cards.length - 1, Math.max(0, index));
      this.dots.forEach((dot, i) => {
        const active = i === this.activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.prevButton) this.prevButton.disabled = this.activeIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex >= this.cards.length - 1;
    }

    onPointerDown(event) {
      if (!this.track || event.pointerType === 'touch') return;
      if (event.target.closest('[data-offer-copy]')) return;
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerId = event.pointerId;
      this.scrollStart = this.track.scrollLeft;
      this.didDrag = false;
      this.dragLock = null;
    }

    onPointerMove(event) {
      if (this.pointerStartX == null || !this.track) return;
      const dx = event.clientX - this.pointerStartX;
      const dy = event.clientY - this.pointerStartY;
      if (this.dragLock == null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          this.dragLock = 'vertical';
          this.pointerStartX = null;
          return;
        }
        this.dragLock = 'horizontal';
        this.didDrag = true;
        this.track.classList.add('is-dragging');
        try {
          this.track.setPointerCapture(this.pointerId);
        } catch (error) {
          /* Capture is optional; native scroll still works. */
        }
      }
      if (this.dragLock !== 'horizontal') return;
      this.track.scrollLeft = this.scrollStart - dx;
    }

    onPointerUp(event) {
      if (this.track?.hasPointerCapture?.(event.pointerId)) {
        this.track.releasePointerCapture(event.pointerId);
      }
      this.pointerStartX = null;
      this.pointerStartY = null;
      this.pointerId = null;
      this.dragLock = null;
      this.track?.classList.remove('is-dragging');
      window.setTimeout(() => {
        this.didDrag = false;
      }, 0);
    }

    onCopy(event) {
      const button = event.currentTarget?.matches?.('[data-offer-copy]')
        ? event.currentTarget
        : event.target.closest('[data-offer-copy]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.didDrag) return;
      const code = button.dataset.coupon;
      if (!code) return;
      const label = button.querySelector('[data-offer-copy-label]');
      const restore = () => {
        button.classList.remove('is-copied');
        if (label) label.textContent = 'Copy';
        button.setAttribute('aria-label', `Copy ${code} coupon code`);
      };
      const copied = () => {
        button.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        button.setAttribute('aria-label', `${code} copied`);
        if (this.liveEl) this.liveEl.textContent = `Copied ${code}`;
        window.clearTimeout(this.copyTimer);
        this.copyTimer = window.setTimeout(() => {
          restore();
          if (this.liveEl) this.liveEl.textContent = '';
        }, 4500);
      };
      const fallback = () => {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
          copied();
        } catch (error) {
          restore();
        }
        document.body.removeChild(input);
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(code).then(copied).catch(fallback);
      } else {
        fallback();
      }
    }
  }

  customElements.define('pdp-offers', PdpOffers);
}
